import { motion } from "framer-motion";
import { Settings as SettingsIcon } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const fadeUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] as [number, number, number, number] },
};

export default function PlatformSettings() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="px-6 py-10 sm:py-16 max-w-3xl mx-auto w-full">
        <motion.div {...fadeUp} className="mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-border bg-card mb-6">
            <SettingsIcon className="w-3.5 h-3.5 text-accent" />
            <span className="font-mono text-xs text-muted-foreground">Settings</span>
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold leading-tight tracking-tight mb-3">
            Platform Settings
          </h1>
          <p className="text-muted-foreground leading-relaxed max-w-lg">
            Configure platform-wide preferences.
          </p>
        </motion.div>

        <motion.div {...fadeUp}>
          <Card>
            <CardHeader>
              <CardTitle className="font-display text-lg">Workspace</CardTitle>
              <CardDescription className="font-mono text-xs">
                Manage workspace settings from the Workspace section.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Additional preferences will appear here as new features are released.
              </p>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
}
